import { action } from '@ember/object';
import Route from '@ember/routing/route';
import type PublicTransition from '@ember/routing/transition';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { decodeAiChatPayload } from 'webapp/utils/ai-chat-payload';

import type GenieChatController from 'webapp/controllers/genie/chat';

export default class GenieChatRoute extends Route {
	@service('ai-chat') declare aiChatService: Service.AIChat;
	@service('infolayer') declare infolayerService: Service.Infolayer;

	override queryParams = {
		chat: { refreshModel: true },
	};

	override beforeModel(): void {
		void this.aiChatService.trackGeniePageView();
	}

	@action
	override willTransition(transition: PublicTransition): void {
		const controller = this.controllerFor(this.routeName) as GenieChatController;

		controller.handleWillTransition(transition);
	}

	override setupController(controller: GenieChatController, model: unknown): void {
		super.setupController(controller, model);

		if (controller.chat) {
			const payload = decodeAiChatPayload(controller.chat);

			if (payload) {
				controller.setup(payload);
			} else {
				this.infolayerService.error('Invalid chat link. Starting a new conversation.');
			}

			controller.chat = null;
		}
	}

	override resetController(controller: GenieChatController, isExiting: boolean): void {
		if (isExiting) {
			controller.reset();
		}
	}
}
